const table = {
  data() {
    return {data: [], loading: true, pageIndex: 1, pageSize: 20, searchData: {}, length: 0, searchForm: {},selectRow:null,
    batteryDetailBar:0,
    boxHeight: 0,
    topheight:0,
    show: false,
    bottomHeight:0}
  },
  computed:{
    tableHeight(){
       let height=  this.boxHeight-this.topheight-170- this.batteryDetailBar; 
       return height;
    }
 },
 mounted() {
  this.router=this.$route;
  this.$nextTick(()=>{
    this.calcTableHeight();
   
  });
  window.addEventListener('resize',this.myFunction);
  

},
  methods: {
    myFunction(){
      if(this.$route.path!== this.router.path){
        return;
      }
      this.calcTableHeight();
    },
    calcTableHeight(){
      this.boxHeight = $('.boxbig').outerHeight(true); //获取boxbig区域高度,带有滚动条'
      this.topheight = $(".main-top").outerHeight(true) + 10;
      },

     searchBorderClick(){
       this.topheight = $(".main-top").outerHeight(true) + 10;
       
     },

    handleSelectionChange(item) {
      this.selectRow = item;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.loadData();
    }, 
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
      this.loadData();
    },

    resetForm() {
      console.log(this.searchData)
      this.$refs.searchForm.resetFields();
      this.searchData = {};
      this.pageIndex = 1;
      this.loadData();
    },
    async loadData(staticLoad=false) {
      if(staticLoad===false){
        this.data = [];
      }
      let queryTime=new Date().getTime()+"_"+Math.random();
      this.queryTime2=queryTime;
      const response = await this.queryList(this.pageIndex, this.pageSize, this.getCacheSearchData());
      if(this.queryTime2!=queryTime){
        return;
      }
      if (response) {
        this.handleData(response.data)
      }else if(staticLoad){
        this.data = [];
      }
    },




    query() {
      this.searchData = this.getSearchData();
      this.pageIndex = 1;
      this.loadData();
    },

    getPageQueryInfo(){
      return {route:this.$route,that:this}
    },

    getCacheSearchData(){
      return {...this.searchData}
    },

    handleData(data) {
      this.length = data.total;
      this.pageSize = data.pageSize;
      this.pageIndex = data.pageNum;
      if(data && data.list != null){
        data.list.forEach((item, i) => {
          item.index = (this.pageIndex - 1) * this.pageSize + i + 1
        })
        this.data = data.list;
      }
     
    }
  }
}
export default table;



// WEBPACK FOOTER //
// ./src/components/Mixin/table.js